import { AIFAQSection } from '../sections/AIFAQSection';
import { AIFinalCTASection } from '../sections/AIFinalCTASection';
import { AIHeroSection } from '../sections/AIHeroSection';
import { AIInnovatorsSection } from '../sections/AIInnovatorsSection';
import { AIKaiCoachSection } from '../sections/AIKaiCoachSection';
// TODO: Re-enable the "Pick the right next step for your role." section later.
// import { AINextStepsSection } from '../sections/AINextStepsSection';
import { AIUCLAStorySection } from '../sections/AIUCLAStorySection';
import { FiveThingsSection } from '../sections/FiveThingsSection';
import { HowKAIWorksSection } from '../sections/HowKAIWorksSection';
import { ValidationResearchSection } from '../sections/ValidationResearchSection';
import { WhatItIsSection } from '../sections/WhatItIsSection';

import { useDocumentTitle } from '@/hooks/useDocumentTitle';

import styles from './AIPage.module.css';

export function AIPage() {
  useDocumentTitle('AI');

  return (
    <div className={styles.page}>
      <AIHeroSection />
      <AIKaiCoachSection />
      <WhatItIsSection />
      <FiveThingsSection />
      <ValidationResearchSection />
      <HowKAIWorksSection />
      <AIInnovatorsSection />
      <AIUCLAStorySection />
      <AIFAQSection />
      {/* TODO: Re-enable the "Pick the right next step for your role." section later. */}
      {/* <AINextStepsSection /> */}
      <AIFinalCTASection />
    </div>
  );
}
